import React, { useContext, useEffect, useState } from "react";
import { TableBody, TableRow, TableCell, Checkbox } from "@mui/material";
import StopRoundedIcon from "@mui/icons-material/StopRounded";
import TableSkeleton from "../../operator/Components/TableSkeleton";
import { NotificationContext } from "../../../context/NotificationContext";

const cellStyle = {
  borderRight: "1px solid #ddd",
  py: 2,
  fontSize: "12px",
  wordWrap: "break-word",
  overflowWrap: "break-word",
};

const factorNameCellStyle = {
  ...cellStyle,
  whiteSpace: "normal",
  wordBreak: "break-word",
  borderLeft: "1px solid #ddd",
};

function MatricesTableBody({
  data,
  loading = false,
  selectedItemIds,
  setSelectedItemIds,
}) {
  // const { selectedItemIds, setSelectedItemIds } =
  //   useContext(NotificationContext);

  // Toggle selection of a factor ID
  const toggleSelect = (factorId) => {
    setSelectedItemIds((prevSelected) =>
      prevSelected.includes(factorId)
        ? prevSelected.filter((id) => id !== factorId)
        : [...prevSelected, factorId]
    );
  };

  useEffect(() => {
    if (
      Array.isArray(data) &&
      data.length > 0 &&
      selectedItemIds.length === 0
    ) {
      toggleSelect(data[0]?.factorId);
    }
  }, [data]);
  const handleCheckboxChange = (event, factorId) => {
    if (!event.target.checked && selectedItemIds.length === 1) {
      return;
    }
    toggleSelect(factorId);
  };

  return (
    <>
      <TableBody>
        {loading ? (
          <tr>
            <td colSpan="4">
              <TableSkeleton />
            </td>
          </tr>
        ) : (
          <>
            {!Array.isArray(data) ||
              (data.length === 0 && (
                <TableRow>
                  <TableCell sx={{ fontWeight: "500" }} colSpan={4}>
                    No data available
                  </TableCell>
                </TableRow>
              ))}
            {data?.map((row, rowIndex) => (
              <TableRow
                key={rowIndex}
                sx={{
                  cursor: "pointer",
                }}
              >
                <TableCell>
                  <span>
                    <Checkbox
                      size="small"
                      sx={{
                        color: "#B4B4B4",
                        padding: "0px",
                        "&.Mui-checked": {
                          color: row?.color || "#34A853",
                        },
                      }}
                      checked={selectedItemIds.includes(row?.factorId)}
                      onChange={(event) =>
                        handleCheckboxChange(event, row?.factorId)
                      }
                    />
                  </span>
                </TableCell>
                <TableCell sx={factorNameCellStyle}>
                  {row?.factorName}
                </TableCell>
                <TableCell sx={cellStyle}>{row?.upperLimit || "NA"}</TableCell>
                <TableCell sx={cellStyle}>{row?.lowerLimit || "NA"}</TableCell>
                {/* <TableCell sx={cellStyle}>{row?.avgDeviation || "NA"}</TableCell> */}
              </TableRow>
            ))}
          </>
        )}
      </TableBody>
    </>
  );
}

export default MatricesTableBody;
